import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import '@/i18n'
import '@/index.css'
import { App } from '@/App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div className="min-h-screen" />}>
      <BrowserRouter>
        <ChatBotProvider>
          <App />
        </ChatBotProvider>
      </BrowserRouter>
    </Suspense>
  </StrictMode>
)
